import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { get } from "@/lib/api";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id") ?? "";
  const qc = useQueryClient();
  const [tries, setTries] = useState(0);
  const q = useQuery({
    queryKey: ["payment", sid], queryFn: () => get(`/payments/status/${sid}`), enabled: !!sid,
    refetchInterval: (query) => { const d = query.state.data; return d && ["paid", "expired"].includes(d.payment_status) ? false : query.state.dataUpdateCount < 15 && 2000; },
  });
  const paid = q.data?.payment_status === "paid";
  useEffect(() => { if (q.dataUpdatedAt) setTries((t) => t + 1); }, [q.dataUpdatedAt]);
  useEffect(() => { if (paid) { qc.invalidateQueries({ queryKey: ["invoices"] }); qc.invalidateQueries({ queryKey: ["jobs"] }); } }, [paid, qc]);
  const failed = !sid || q.isError || q.data?.payment_status === "expired" || (!paid && tries >= 15);
  return (
    <div className="mx-auto max-w-lg px-4 py-20 text-center" data-testid="payment-result">
      {paid ? <CheckCircle2 className="mx-auto size-14 text-emerald-600" /> : failed ? <XCircle className="mx-auto size-14 text-rose-600" /> : <Loader2 className="mx-auto size-14 animate-spin text-orange-600" />}
      <h1 className="mt-4 font-heading text-3xl font-extrabold">{paid ? "¡Pago completado!" : failed ? "No hemos podido confirmar el pago" : "Confirmando tu pago…"}</h1>
      <p className="mt-2 text-slate-600">{paid ? "Tu factura queda marcada como pagada. Gracias por confiar en HandyZoom." : failed ? "Si se ha realizado el cargo, aparecerá en tus facturas en unos minutos." : "Esto tarda solo unos segundos."}</p>
      <Button asChild className="mt-6 rounded-xl"><Link to="/facturas" data-testid="payment-go-invoices">Ver mis facturas</Link></Button>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="mx-auto max-w-lg px-4 py-20 text-center" data-testid="payment-cancel">
      <XCircle className="mx-auto size-14 text-slate-400" />
      <h1 className="mt-4 font-heading text-3xl font-extrabold">Pago cancelado</h1>
      <p className="mt-2 text-slate-600">No se ha realizado ningún cargo. Puedes pagar la factura cuando quieras.</p>
      <Button asChild className="mt-6 rounded-xl"><Link to="/facturas">Volver a facturas</Link></Button>
    </div>
  );
}
